import './chartjs.js'

export default './chartjs.js'
